module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-03.1a46a3fe.png";